import { render } from "./archiveComponent.vue?vue&type=template&id=2eb01b40"
import script from "./archiveComponent.vue?vue&type=script&lang=js"
export * from "./archiveComponent.vue?vue&type=script&lang=js"

import "./archiveComponent.vue?vue&type=style&index=0&id=2eb01b40&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__